import { render, staticRenderFns } from "./FreelancerCard.vue?vue&type=template&id=38980017&scoped=true&"
import script from "./FreelancerCard.vue?vue&type=script&lang=js&"
export * from "./FreelancerCard.vue?vue&type=script&lang=js&"
import style0 from "./FreelancerCard.vue?vue&type=style&index=0&id=38980017&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38980017",
  null
  
)

export default component.exports